import type { RootOptions } from "react-dom/client";

import type { Sentry } from "./sentry";

const toError = (error: unknown): Error => (error instanceof Error ? error : new Error(String(error)));

/**
 * React 19 no longer re-throws errors that happen during render, so they never reach the global
 * `window.onerror` handler Sentry hooks into. Roots have to forward them explicitly.
 *
 * @see https://react.dev/blog/2024/04/25/react-19-upgrade-guide#errors-in-render-are-not-re-thrown
 */
const sentryRootOptions = (sentry: Sentry): RootOptions => {
  const report = (error: unknown) => sentry.captureException(toError(error));

  return {
    onUncaughtError: report,
    onCaughtError: report,
    onRecoverableError: report
  };
};

export default sentryRootOptions;
